import { ReactNode } from 'react';
import ReactDOM from 'react-dom/client';

let customDialog: any;
let div: any;

export function show(content: ReactNode) {
  hide();
  div = document.createElement('div');
  document.body.appendChild(div);
  customDialog = ReactDOM.createRoot(div);
  customDialog.render(content);
}

export function hide() {
  if (customDialog) {
    customDialog.unmount();
    customDialog = null;
  }
  if (div) {
    document.body.removeChild(div);
    div = null;
  }
}
interface Props {
  bottom?: boolean;
  children: ReactNode;
  onClose: () => void;
  className?: string;
  maskClose?: boolean;
}
export function CustomDialog({ children, onClose, className, maskClose = true, bottom }: Props) {
  return (
    <div className={`custom-dialog ${bottom ? 'bottom' : ''} ${className}`}>
      <div className="custom-mask" onClick={maskClose ? () => onClose() : undefined} />
      <div className={`custom-content ${bottom ? 'bottom' : ''}`}>{children}</div>
    </div>
  );
}
interface CustomDialogTitleProps {
  title: string;
  className?: string;
  showCloseIcon?: boolean;
  onClose?: () => void;
}
export function CustomDialogTitle({ title, className, showCloseIcon, onClose }: CustomDialogTitleProps) {
  return (
    <div className={`custom-title ${className}`}>
      {showCloseIcon && <div className="icon-20"></div>}
      <div className="flex-1">{title}</div>
      {showCloseIcon && <img src="/img/icon_action_close.png" className="icon-20" alt="" onClick={onClose} />}
    </div>
  );
}

export function BottomSheetTitle({ title, onClose, className }: CustomDialogTitleProps) {
  return (
    <div className={`d-flex-r align-items-center just-content-between ${className}`}>
      <div className="icon-20" />
      <div className="text-center">{title}</div>
      {onClose ? (
        <img onClick={onClose!} className="icon-20" src="/img/icon_action_close.png" alt="" />
      ) : (
        <div className="icon-20" />
      )}
    </div>
  );
}

export interface CustomDialogAction {
  label: string;
  primary?: boolean;
  clickValue?: any;
  onClick?: () => void;
}
interface CustomDialogActionsProps {
  actions?: CustomDialogAction[];
  onClick: (index: number | string) => void;
}
export function CustomDialogActions({ actions, onClick }: CustomDialogActionsProps) {
  let _a = actions || [];
  return (
    <div className="custom-bottom">
      {_a.map((item, idx) => (
        <div
          key={item.label + idx}
          className={`action ${item.primary ? 'primary' : ''} `}
          onClick={() => {
            onClick(item.clickValue ?? idx);
            item.onClick && item.onClick();
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}
